// Simple React Validator v0.0.5 | Created By Dockwa | MIT License | 2017
!function (e, t) {
  "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? module.exports = t(require("react")) : e.SimpleReactValidator = t(e.React);
}(this, function (e) {
  "use strict";

  function t(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var s in r) {
        Object.prototype.hasOwnProperty.call(r, s) && (e[s] = r[s]);
      }
    }

    return e;
  },
      s = function () {
    function e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var s = t[r];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
      }
    }

    return function (t, r, s) {
      return r && e(t.prototype, r), s && e(t, s), t;
    };
  }();

  return function () {
    function n() {
      var e = this,
          s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      t(this, n), this.fields = {}, this.errorMessages = {}, this.messagesShown = !1, this.rules = r({
        accepted: {
          message: "The :attribute must be accepted.",
          rule: function rule(e) {
            return !0 === e;
          }
        },
        alpha: {
          message: "The :attribute may only contain letters.",
          rule: function rule(t) {
            return e._testRegex(t, /^[A-Z]*$/i);
          }
        },
        alpha_num: {
          message: "The :attribute may only contain letters and numbers.",
          rule: function rule(t) {
            return e._testRegex(t, /^[A-Z0-9]*$/i);
          }
        },
        alpha_num_dash: {
          message: "The :attribute may only contain letters, numbers, and dashes.",
          rule: function rule(t) {
            return e._testRegex(t, /^[A-Z0-9_-]*$/i);
          }
        },
        card_exp: {
          message: "The :attribute must be a valid expiration date.",
          rule: function rule(t) {
            return e._testRegex(t, /^(([0]?[1-9]{1})|([1]{1}[0-2]{1}))\s?\/\s?(\d{2}|\d{4})$/);
          }
        },
        card_num: {
          message: "The :attribute must be a valid credit card number.",
          rule: function rule(t) {
            return e._testRegex(t, /^\d{4}\s?\d{4,6}\s?\d{4,5}\s?\d{0,8}$/);
          }
        },
        email: {
          message: "The :attribute must be a valid email address.",
          rule: function rule(t) {
            return e._testRegex(t, /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
          }
        },
        gt: {
          message: "The :attribute must be greater than :gt.",
          rule: function rule(t, r) {
            return !!e._testRegex(t, /^\d+.?\d*$/) && parseFloat(t) > parseFloat(r[0]);
          },
          messageReplace: function messageReplace(e, t) {
            return e.replace(":gt", t[0]);
          }
        },
        gte: {
          message: "The :attribute must be greater than or equal to :gte.",
          rule: function rule(t, r) {
            return !!e._testRegex(t, /^\d+.?\d*$/) && parseFloat(t) >= parseFloat(r[0]);
          },
          messageReplace: function messageReplace(e, t) {
            return e.replace(":gte", t[0]);
          }
        },
        in: {
          message: "The selected :attribute must be :values.",
          rule: function rule(e, t) {
            return t.indexOf(e) > -1;
          },
          messageReplace: function messageReplace(t, r) {
            return t.replace(":values", e._toSentence(r));
          }
        },
        integer: {
          message: "The :attribute must be an integer.",
          rule: function rule(t) {
            return e._testRegex(t, /^\d+$/);
          }
        },
        lt: {
          message: "The :attribute must be less than :lt.",
          rule: function rule(t, r) {
            return !!e._testRegex(t, /^\d+.?\d*$/) && parseFloat(t) < parseFloat(r[0]);
          },
          messageReplace: function messageReplace(e, t) {
            return e.replace(":lt", t[0]);
          }
        },
        lte: {
          message: "The :attribute must be less than or equal to :lte.",
          rule: function rule(t, r) {
            return !!e._testRegex(t, /^\d+.?\d*$/) && parseFloat(t) <= parseFloat(r[0]);
          },
          messageReplace: function messageReplace(e, t) {
            return e.replace(":lte", t[0]);
          }
        },
        max: {
          message: "The :attribute may not be greater than :max characters.",
          rule: function rule(e, t) {
            return e.length <= t[0];
          },
          messageReplace: function messageReplace(e, t) {
            return e.replace(":max", t[0]);
          }
        },
        min: {
          message: "The :attribute must be at least :min characters.",
          rule: function rule(e, t) {
            return e.length >= t[0];
          },
          messageReplace: function messageReplace(e, t) {
            return e.replace(":min", t[0]);
          }
        },
        not_in: {
          message: "The selected :attribute must not be :values.",
          rule: function rule(e, t) {
            return -1 === t.indexOf(e);
          },
          messageReplace: function messageReplace(t, r) {
            return t.replace(":values", e._toSentence(r));
          }
        },
        numeric: {
          message: "The :attribute must be a number.",
          rule: function rule(t) {
            return e._testRegex(t, /^\d+.?\d*$/);
          }
        },
        phone: {
          message: "The :attribute must be a valid phone number.",
          rule: function rule(t) {
            return e._testRegex(t, /(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)/);
          }
        },
        required: {
          message: "The :attribute field is required.",
          rule: function rule(t) {
            return e._testRegex(t, /.+/);
          }
        },
        url: {
          message: "The :attribute must be a url.",
          rule: function rule(t) {
            return e._testRegex(t, /^(https?|ftp):\/\/(-\.)?([^\s\/?\.#-]+\.?)+(\/[^\s]*)?$/i);
          }
        }
      }, s);
    }

    return s(n, [{
      key: "getErrorMessages",
      value: function value() {
        return this.errorMessages;
      }
    }, {
      key: "showMessages",
      value: function value() {
        this.messagesShown = !0;
      }
    }, {
      key: "hideMessages",
      value: function value() {
        this.messagesShown = !1;
      }
    }, {
      key: "allValid",
      value: function value() {
        for (var e in this.fields) {
          if (!1 === this.fieldValid(e)) return !1;
        }

        return !0;
      }
    }, {
      key: "fieldValid",
      value: function value(e) {
        return this.fields.hasOwnProperty(e) && !0 === this.fields[e];
      }
    }, {
      key: "customMessage",
      value: function value(e, t) {
        if (e && this.messagesShown) return this._reactErrorElement(e, t);
      }
    }, {
      key: "message",
      value: function value(e, t, r, s) {
        var n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
        this.errorMessages[e] = null, this.fields[e] = !0;

        for (var a, u, i, l = r.split("|"), o = 0; o < l.length; o++) {
          if (t = this._valueOrEmptyString(t), a = this._getRule(l[o]), u = this._getOptions(l[o]), !1 === this.rules[a].rule(t, u) && (this.fields[e] = !1, this.messagesShown)) return i = n[a] || n.default || this.rules[a].message.replace(":attribute", e.replace(/_/g, " ")), this.errorMessages[e] = i, u.length > 0 && this.rules[a].hasOwnProperty("messageReplace") ? this._reactErrorElement(this.rules[a].messageReplace(i, u)) : this._reactErrorElement(i, s);
        }
      }
    }, {
      key: "_getRule",
      value: function value(e) {
        return e.split(":")[0];
      }
    }, {
      key: "_getOptions",
      value: function value(e) {
        var t = e.split(":");
        return t.length > 1 ? t[1].split(",") : [];
      }
    }, {
      key: "_valueOrEmptyString",
      value: function value(e) {
        return void 0 === e || null === e ? "" : e;
      }
    }, {
      key: "_toSentence",
      value: function value(e) {
        return e.slice(0, -2).join(", ") + (e.slice(0, -2).length ? ", " : "") + e.slice(-2).join(e.length > 2 ? ", or " : " or ");
      }
    }, {
      key: "_reactErrorElement",
      value: function value(t, r) {
        return e.createElement("div", {
          className: r || "validation-message"
        }, t);
      }
    }, {
      key: "_testRegex",
      value: function value(e, t) {
        return null !== e.toString().match(t);
      }
    }]), n;
  }();
});